export default "/assets/images/technology-graph-04.svg?a31e0d66328381884df65498d4ca2663";